<template>
  <v-dialog v-model="intDialogVisible" max-width="800px" class="addValueModal addComment">
    <v-card>
      <!-- <v-card-title>
        <span @click="close" class="close">X</span>
      </v-card-title> -->
      <v-card-text>
        <div class="row text-center">
          <h3 class="primary--text formName">{{$t("How would you like to run this assessment ?")}}</h3>

        </div>
        <div class="row mt20">
          <div class="assessment-type">
            <label class="radio-label">
              <input
                type="radio"
                :value="false"
                v-model="isnew"
              />
              <span class="custom-radio"></span>
              <span class="radio-text">{{ $t("Existing assessment")}}</span>
            </label>
            <label class="radio-label">
              <input
                type="radio"
                :value="true"
                v-model="isnew"
              />
              <span class="custom-radio"></span>
              <span class="radio-text">{{ $t("New assessment")}}</span>
            </label>
          </div>
        </div>
        <div class="row" v-if="isnew == false">
          <div class="zone_input" >
            <div class="zone_input_header">
              <span class="zone_input_name">{{ $t("Assessment")}}*</span>
            </div>
              <select class="innopearl_input"  v-model="toExistingOne">
                <option v-for="(a, p ) in availableAssessment " :key="p" :value="a">{{a.name}}</option>
              </select>
              <!-- <v-autocomplete v-model="internalAssessment.procjet" closable-chips  :items="projects" item-color="#FFF" item-title="name" item-value="value"  chips multiple></v-autocomplete> -->

          </div>
        </div>
        <div class="row " v-if="isnew == true">

          <div class="col-12 col-lg-6 mt20" >
              <label class="assessTypeChoice" :class="(typeAssessment == 'internal') ? 'selected' : ''">
                <input type="radio" name="assessTypeChoice" id="assessTypeChoice" v-model="typeAssessment" value="internal"/>
                <span class="assessTypeChoiceTitle">{{$t("Assessment by ")}}<br/><strong>{{$t("internal experts")}}</strong></span>
                <img class="imageInternal" :src="require('@/assets/internalAssess.png')" alt=""/>
              </label>
          </div>
          <div class="col-12 col-lg-6 mt20">
            <label class="assessTypeChoice"  :class="(typeAssessment == 'innopearl') ? 'selected' : ''">
              <input type="radio" name="assessTypeChoice" id="assessTypeChoice" v-model="typeAssessment" value="innopearl"/>

              <span class="assessTypeChoiceTitle">{{$t("Assessment by ")}}<br/><strong>{{$t("Innopearl")}}</strong></span>
              <img class="imageInno" :src="require('@/assets/innoAssess.png')" alt=""/>

            </label>
          </div>
        </div>
        <div class="row mt20" v-if="typeAssessment == 'internal'">
          <div class="zone_input mt20" >
            <div class="zone_input_header">
              <span class="zone_input_name">{{ $t("Assessment name")}}*</span>
            </div>
            <input type="text"  maxLength="30" class="innopearl_input" v-model="assessmentname">
          </div>
        </div>
        <div class="row mt20" v-if="typeAssessment == 'innopearl'">
          <div class="zone_input mt20" >
            <div class="zone_input_header">
              <span class="zone_input_name">{{ $t("Assessment name")}}*</span>
            </div>
            <input type="text"  maxLength="30" class="innopearl_input" v-model="assessmentname">
          </div>
          <div class="zone_input mt20" >
            <div class="zone_input_header">
              <span class="zone_input_name">{{ $t("Project")}}*</span>
            </div>
            <select class="innopearl_input"  v-model="selectedProject">
              <option v-for="(a, p ) in availableProject " :key="p" :value="a">{{a.name}}</option>
            </select>
          </div>
          <div class="zone_input mt20"  v-if="selectedProject">
            <div class="zone_input_header">
              <span class="zone_input_name">{{ $t("Search field")}}*</span>
            </div>
            <select class="innopearl_input"  v-model="selectedSF">
              <option v-for="(a, p ) in selectedProject.search_field " :key="p" :value="a">{{a.name}}</option>
            </select>
          </div>
        </div>
        <div class=" actionButn mt20">
            <button class="mt20 smallModalBtnInverted" type="button" @click="close" name="button">Cancel</button>
            <button class="mt20 smallModalBtn" type="button" :disabled="!isOk()" @click="confirm" name="button">Confirm</button>
        </div>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/tools/api';
export default {
  props: {
    dialogVisible: Boolean,
  },
  data () {
    return{
      typeAssessment: null,
      assessmentname:"",
      isnew:null,
      availableAssessment: [],
      toExistingOne : null,
      availableProject : [],
      selectedProject:null,
      selectedSF:null,
    }
  },
  methods:{
    close(){
        this.$emit('close',false)
    },
    isOk(){
      if(this.isnew == null){
        return false;
      }
      else{
        if(this.isnew == true){
          if(!this.typeAssessment) return false;
          if(this.typeAssessment == "internal"){
            if(this.assessmentname.trim() == '')return false;
          }
          else{
            if(this.selectedSF == null)return false;
          }
        }
        else{
          if(!this.toExistingOne)return false;
        }
      }
      return true;
    },
    confirm(){
      if(this.isnew == true){
        if(this.typeAssessment == "internal"){
          this.$emit('newInternal',this.assessmentname)
        }
        else{
          var data = {
            sf : this.selectedSF,
            project : this.selectedProject,
            name : this.assessmentname
          };
          this.$emit('newInnopearl',data)
        }
      }
      else{

        this.$emit('existingInternal',this.toExistingOne)
      }
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    }
  },
  watch: {
    dialogVisible: function(){

      this.typeAssessment = null;
      this.assessmentname = "";
      this.isnew = null;
      this.availableAssessment = [];
      this.toExistingOne = null;
      this.selectedProject = null;
      this.selectedSF = null;
      if(this.dialogVisible == true){
        api.get(process.env.VUE_APP_API_URL+"/restrict/my_initiated_assessment").then( (r) => {
          console.log("IS ASSESS");
          console.log(r.data);
          this.availableAssessment = r.data;


        });
        api.get(process.env.VUE_APP_API_URL+"/restrict/projects").then( (r) => {
          this.availableProject = r.data;
          console.log(r.data);
          console.log(r);
        }).catch( (e) => console.log(e));

      }
    },
    selectedProject: function(){

      this.selectedSF = null;
      this.availabeSearchField = (this.selectedProject) ? this.selectedProject.search_field : [];
    }
  }

}
</script>

<style media="screen" scoped>
  .addValueModal .v-card{
    padding:20px;
    padding-top:20px;
    padding-bottom: 50px;
    border-radius: 20px;
  }
  .addValueModal .v-field__outline{
    display:none;
  }
  .mt20{
    margin-top:20px;
  }
  .formName{
    text-align: center;
    font-size: 21px;
    line-height: 25px;
    color: #3783C5;
    font-weight: 600;
  }


.close{
  position: absolute;
    right: 0;
    top: 0;
    padding: 5px 15px;
    background: #4C81C0;
    color: #FFF;
    cursor: pointer;
    font-size: 14px;
    line-height: 25px;
}
.formName{
  padding-right:30px;
}
.flexIt{
  display:flex;
  width:100%;
  flex-wrap: wrap;
  gap: 20px;
  margin-top:10px;
  align-content: center;
  align-items: center;
  align-self: center;
}

.assessTypeChoice{
  background:#F0F5FA;
  border-radius:25px;
  border:2px solid #F0F5FA;
  padding:25px;
  text-align:center;
  width:100%;
  display:flex;
  flex-direction: column;
  gap:20px;
  height: 100%;
}

.assessTypeChoice.selected{
  border-color:#3783C5;
}

.assessTypeChoice input{
  display:none;
}

.imageInternal{
  transform: translateY(25px);
    width: 200px;
    margin: auto;
}
.imageInno{
  width:130px;
  margin:auto;
}

.actionButn{
  display:flex;gap:20px;flex-direction: row;justify-content: center;
}

.smallModalBtn{
  background: #4C81C0;
  border:1px solid #4C81C0;
  color: #fff !important;
  font-size:15px !important;
  padding: 7px 30px !important;
  border-radius: 50px;
}

.smallModalBtnInverted{
  background: #FFF;
    border:1px solid #4C81C0;
  color: #4C81C0 !important;
  font-size:15px !important;
  padding: 7px 30px !important;
  border-radius: 50px;
}

.smallModalBtn:disabled{
opacity:0.2;
}


  .assessment-type {
      display: flex;
      align-items: center;
      margin-bottom:30px;
  }

  .radio-label {
      display: flex;
      align-items: center;
      margin-right: 20px; /* Spacing between options */
      cursor: pointer; /* Change cursor to pointer for better UX */
  }

  input[type="radio"] {
      display: none; /* Hide the default radio button */
  }

  .custom-radio {
      width: 25px; /* Circle diameter */
      height: 25px; /* Circle diameter */
      border: 2px solid #5081C1; /* Light gray border for unselected state */
      border-radius: 50%; /* Make it a circle */
      margin-right: 8px; /* Space between the circle and the text */
      transition: border-color 0.3s, background-color 0.3s; /* Smooth transition for color changes */
  }

  .radio-text {
      font-weight: 600;
      color: #04246A; /* Dark color for the text */
  }

  input[type="radio"]:checked + .custom-radio {
      border-color: #5081C1; /* Change border color when selected */
      background-color: #5081C1; /* Blue background when selected */
  }

  .zone_input_name{
    text-align: left;
    font-size: 18px;
    line-height: 21px;
    color: rgba(4, 36, 106, 1);
    font-weight: 600;
    margin-bottom:10px;
  }
  .zone_input_header{
    display:flex;
    gap: 10px;
    position:relative;
  }

  .innopearl_input{
    border: 1px solid #DDDDDD;
  border-radius: 2px;
  box-sizing: border-box;

  height: 40px;
  padding: 5px;
  width:100%;
  }
  @media screen and (max-width: 990px){
  .innopearl_input{
    width:100%;
    margin-left:0;
  }
  }
</style>
